import { BlogListItemType, CategoryType, HelpCenterListItemType } from '@application/Types/ComponentTypes'

import { getPageUrl } from '../../../Application/Utils/generalUtils'

export const removeDoubleSlash = (url: string): string => url.replace(/\/\//gi, '/')

export const localizeUrl = (locale: string, url: string): string => {
    const fullPath = locale === 'en' ? url : `/${locale}/${url}`

    return removeDoubleSlash(fullPath)
}

export const localizeCategoryUrl = (categories: CategoryType[]): CategoryType[] => {
    return categories.map((category) => {
        return { ...category, categoryUrl: localizeUrl(category.language, category.categoryUrl) }
    })
}

export const localizeArticleUrl = (
    articles: BlogListItemType[] | HelpCenterListItemType[]
): BlogListItemType[] | HelpCenterListItemType[] => {
    return articles.map((article) => {
        return { ...article, pageUrl: localizeUrl(article.language, getPageUrl(article)) }
    })
}
